import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../../../constants/Languages.js';

//import components
import ItemText from '../../ItemText.js';
import ItemListSeparate from '../../ItemListSeparate.js';
import ItemListInline from '../../ItemListInline.js';
import ItemSubSection from '../../ItemSubSection.js';
import ItemNested from '../../ItemNested.js';
import ItemSubSectionSeparate from '../../ItemSubSectionSeparate.js';
import ItemOtherNames from '../../ItemOtherNames.js';

const CardSection = ({clang, text, label, data, type}) => {
    const getDataItem = (item) => {
        let component;
        console.log('ITEM:', item);
        switch(item.label) {
            case 'typesEvent':
            case 'typesSeries':
            case 'typesEventSeries':
            case 'typesInstitution':
            case 'locationsEvent':
            case 'characters':
            // case 'authorCompany':
                component = <ItemListInline list={item.val}/>;
                break;
            case 'mailingParts':
            case 'interviewParts':
                component = <ItemSubSectionSeparate desc={item.val.desc} items={item.val.items}/>;
                break;
            case 'awards':
                component = item.val.map((itemVal, index) =>
                              <div key={index} className="card__award">
                                  <div className="card__award__name"><ItemText text={itemVal.label}/></div>
                                  <ItemSubSection list={itemVal.linkedFilesAndRecords}/>
                                  <div className="card__award__separator"></div>
                              </div>);
                break;
            case 'relationsEvent':
            case 'relationsEventSeries':
            case 'relationsInstitution':
                component = item.val.map((itemVal, index) =>
                              <div key={index} className="card__relations">
                                  <div className="card__relations__type">
                                      <ItemText text={`${lang[clang].item.card[itemVal.type]}:`}/>
                                      <ItemText text={itemVal.target.label} link={itemVal.target.link} type={itemVal.target.entityType}/>
                                  </div>
                                  {itemVal.periodInfo &&
                                      <div className="card__relations__period">
                                          <ItemText text={`${lang[clang].item.card.relationPeriod}: ${itemVal.periodInfo}`}/>
                                      </div>}
                                  <div className="card__relations__separator"></div>
                              </div>);
                break;
            case 'linkedFilesAndRecords':
                component = <ItemSubSection list={item.val} seeMore={item.label === "linkedFilesAndRecords"}/>;
                break;
            case 'birthLocation':
            case 'deathLocation':
            case 'publicationFrequency':
            case 'publishingSeries':
            case 'journal':
            case 'source':
            case 'journal-number':
            case 'country':
                component = <ItemText text={item.val.label} link={item.val.link}/>;
                break;
            case 'baseTitle':
            case 'title':
            case 'unitTitle':
            case 'incipit':
            case 'incipitTitle':
            case 'dedication':
            case 'otherTitle':
            case 'translationBase':
            case 'originalTitle':
                component = <ItemText text={item.val.label} isTransit={item.val.transliterated}/>;
                break;            
            case 'groupAlias':
            case 'triggerInstitutions':
            case 'publishingHouses':
            case 'places':
            case 'additionTo':
            case 'contains':
            case 'previousTitle':
            case 'nextTitle':
            case 'authors':
            case 'sources':
            case 'otherTitleEvent':
            case 'organizersEvent':
            case 'organizers':
            case 'belongingToEventSeries':
            case 'namePlaces':
            case 'mainName':
            case 'otherName':
            case 'familyName':
            case 'monasticName':
            case 'codename':
            case 'alias':
                component = <ItemListSeparate list={item.val}/>;
                break;
            case 'edition':
            case 'annotations':
            case 'dateEvent':
            case 'birthDate':
            case 'deathDate':
            case 'sex':
            case 'issn':
            case 'physicalDeficiencies':
            case 'publishedFromTo':
            case 'translationBaseLang':
            case 'titleOriginalLang':
            case 'namePeriodInfoCycle':
            case 'namePeriodInfo':
            case 'country':
                component = <ItemText text={item.val}/>;
                break;        
            case 'headings':
            case 'secondaryHeadings':
                component = item.val.map((itemVal, index) => {
                              const domain = itemVal.filter(listItem => listItem.entityType === 'domain')[0];
                              const newList = itemVal.filter(listItem => listItem.entityType !== 'domain');

                              if (!domain || !newList ) return false;

                              return (
                                        <ItemNested 
                                            list={newList} 
                                            domain={domain} 
                                            key={index} 
                                            type={item.label}
                                        />
                              );
                            });
                break;
            case 'otherNames':
                component = <ItemOtherNames list={item.val} dateLabel={lang[clang].item.card.otherNamesEventSeries}/>;
                break;
            case 'otherNamesInstitution':
                component = <ItemOtherNames list={item.val} dateLabel={lang[clang].item.card.otherNamesInstitution} placesLabel={lang[clang].item.card.otherNamesPlacesInstitution}/>;
                break;
            default:
                break;
        }

        switch(label) {
            case 'external_links':
                component = (
                    <div>
                        <ItemText text={item.val.label} link={item.val.link} newTab={true}/>
                        <ItemText text={item.val.desc} type="externalLinks"/>
                    </div>
                );
                break;
            default:
                break;
        }

        if (!component) {
            return false;
        }

        return (
            <div className="card__section__data-item" key={item.label}>
                <label className="card__section__data-label">
                    { lang[clang].item.card[item.label] 
                        ? (<span>{lang[clang].item.card[item.label]}:</span>)
                        : (<span>{item.label}:</span>)
                    }
                </label>
                <div className="card__section__data-container">
                    {component}
                </div>
            </div>
        );
    };

    return (
        <div className="card__section">
            <h4 className="card__section-label" dangerouslySetInnerHTML={{__html: lang[clang].item[label]}}></h4>
            <div className="card__section__data">
                {data.map(dataItem => dataItem.val ? getDataItem(dataItem) : false)}
            </div>
        </div>
    );
};

CardSection.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(CardSection);



// WEBPACK FOOTER //
// ./src/components/items/cards/common/CardSection.js